import { Component, OnInit, AfterViewInit, HostListener } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  AbstractControl,
} from "@angular/forms";
import {
  KreFormOptions,
  KreFormFieldConfig,
  KreTableFieldConfig,
  Field,
  KreFormCommonService,
  KreFormBuilder,
  FormGlobalService,
} from "@kre-form/core";

import { KreFormIonDialogService } from "@kre-form/ionic";
@Component({
  selector: "ui-ionic",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"],
})
export class UIIONICComponent implements OnInit, AfterViewInit {
  skeletonStatus = 0;
  form = new FormGroup({});
  model: any = {
    costcenter$cc_costcenter$remark: "2021-12-12T08:08:00",
  };
  options = {};
  formFildConfig: KreFormFieldConfig[] = [];

  repeatRole = {};

  ngOnInit() {
    this.form = this.fb.group({
      password: [null, [Validators.required]],
    });
    let config = this.getFormFieldConfig();

    let role = {
      panel1_text: {
        tags: null,
      },
      key1: {
        show: true,
        editor: true,
        required: true,
        enableInterface: true,
        modalField: ["key1", "key2"],
      },
      key2: {
        show: true,
        editor: true,
        required: true,
        enableInterface: true,
        modalField: ["key1", "key2"],
      },
    };
    let option = {
      busitrip$employeebusitripapply$busitripstarttime: [
        { label: "aa", value: "bb11" },
      ],
      // key2: [
      //   { value: "a", label: "选项1" },
      //   { value: "b", label: "选项2" },
      // ],
    };

    /*
      初始化FormJSON体，最后一个参数是组件事件触发回调函数
    */
    if (!!this.repeatRole) {
      config.forEach((el) => {
        if (!!this.repeatRole[el.key]) {
          el.repeatRole = this.repeatRole[el.key];
        }
      });
    }
    this.kreFormCommonService.initFormFieldConfig(
      config,
      role,
      option,
      this.model,
      this,
      (e, field) => {
        // let res = {
        //   // overtimesplit$overtimerecorddetail$overtimecode: {
        //   //   // value: [{ label: 1, value: 1 }],
        //   //   // value: [],
        //   //   value: [{ label: 1, value: 1 }],

        //   //   editor: true,
        //   //   show: true,
        //   // },
        //   numbers: {
        //     value: 10.5,
        //   },
        // };
        // this.kreFormCommonService.setRuleExecuteConfig(config, this.model, res);

        // (<any>this.options)._buildForm(true);
        console.log(this.model);
      },
      "mobile"
    );

    this.formFildConfig = config;
  }

  constructor(
    private fb: FormBuilder,
    public kreFormCommonService: KreFormCommonService,

    public formBuilder: KreFormBuilder,
    public globalService: FormGlobalService
  ) {
    this.globalService.subscribe(
      "DateTimeClick",
      (e: { rdm: number; config: KreFormFieldConfig; type?: string }) => {
        console.log(e);

        // switch (e.config.key) {
        //   default:
        //     break;
        // }
        // if (!!e.type) {
        //   this.setRuleExe(null, e.config, null);
        // }
      }
    );
    this.globalService.subscribe("TabularAdd", (res: any) => {
      res = res.config;
      this.formFildConfig.forEach((field: any) => {
        if (field.key === res.key) {
          let rowKey = `${res.key}_${res.fieldGroup.length}`;
          let item: any = this.getTabularItem(
            rowKey,
            res.templateOptions.fieldGroup,
            res.fieldGroup.length
          );
          field.fieldGroup.push(item);
        }
      });
      (<any>this.options)._buildForm(true);
    });

    this.globalService.subscribe("TabularDel", (res: any) => {
      let i = res.number;
      res = res.config;

      this.formFildConfig.forEach((field: any) => {
        if (field.key === res.key) {
          field.fieldGroup = field.fieldGroup.filter(
            (item: any, index: any) => {
              return index != i;
            }
          );
        }
      });
      (<any>this.options)._buildForm(true);
    });
    this.globalService.subscribe("FieldWrapperClick", (res: any) => {
      console.log(res);
    });
  }

  getTabularItem(key: any, filedGroup: any[], e: any) {
    // let group: any[] = _.cloneDeep(filedGroup);
    // group.forEach((item: any) => {
    //   item.key = `${key}_${item.key}`;
    // });
    // let item: any = {
    //   type: "panel",
    //   key: `${key}`,
    //   templateOptions: {
    //     label: `${key}`,
    //   },
    //   fieldGroup: group,
    // };
    // return item;
    return null;
  }

  setTabularConfig(fieldConfig: KreFormFieldConfig[]) {
    fieldConfig.forEach((field: any) => {
      if (field.type == "tabular") {
        if (this.model[field.key] && this.model[field.key]!!) {
          for (let key in this.model[field.key]) {
            let item: any = this.getTabularItem(
              key,
              field.templateOptions.fieldGroup,
              field.fieldGroup.length
            );
            field.fieldGroup.push(item);
          }
        }
      }
    });
  }

  ngAfterViewInit() {}

  submit() {
    console.log(this.model);
    // if (this.form.valid) {
    //   alert("OK");
    // }
  }

  getFormFieldConfig() {
    let config: KreFormFieldConfig[] = [
      {
        key: "costcenter$cc_costcenter$remark",
        type: "datetime",
        defaultValue: null,
        defaultText: null,
        editor: true,
        show: true,
        tableCode: "CC_CostCenter",
        className: null,
        templateOptions: {
          type: "datetime",
          // type: null,
          // label: "描述",
          // labelI18n: null,
          // isButintin: false,
          // required: false,
          // placeholder: null,
          // minLength: null,
          // maxLength: 500,
          // format: null,
          // maxDate: null,
          // minDate: null,
          // max: null,
          // min: null,
          // precision: 0.0,
          // selectType: null,
          // parameterId: null,
          // pattern: null,
          // description: null,
          enableInterface: true,
          // isNav: null,
          // modalField: null,
          // hideLabel: false,
          // options: null,
          // unit: null,
          // button: null,
          // tags: null,
          // hideSelect: null,
          // hiddenTree: false,
        },
        // fieldArray: { fieldGroup: null },
        // fieldGroup: null,
        // editProperty: null,
        // operationProperty: null,
      },
    ];
    this.setTabularConfig(config);
    return config;
  }
}

/*
      max:0
      min:0
      maxLength:0
      minLength:0
      required:true
      pattern: "[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}"

      -----------------------------
      onInit: field => {
            field.formControl.valueChanges.subscribe(e => {
              this.form.get("table1;age1").setValue(e);
              this.form.get("table1;age1").markAsDirty();
            });
          }

  */
/* for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (!this.form.valid) {
      alert("ERROR");
    } */
